import React from 'react';
import { useMediaQuery } from 'react-responsive';
import MarketingContent from './MarketingContent';

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};

const MobileResponsive = ({ history }) => (
  <Mobile>
    <MarketingContent history={history} />
  </Mobile>
);

export default MobileResponsive;
